module.exports = __webpack_public_path__ + "static/team-8-7ad40b2e12f824f647e75e00e76194b2.jpg";